module.exports = __webpack_public_path__ + "static/img/1-huawei.b0909657.png";